import { pluralizeHours } from '@/tools/pluralize';
import isArrayNotEmpty from '@/tools/isarraynotempty';
import { IParseSubjects, Subjects } from './types';

const parseSubject = (data: IParseSubjects) => ({
  description: data!.description || '',
  hoursWeek:
    data && data.hours_week
      ? `${pluralizeHours(parseFloat(data.hours_week))} в неделю`
      : '',
  subjectName: data!.subject_name || '',
  teacherName: data!.teacher_name || '',
});

const parseSubjects = (data: Subjects) => {
  if (!isArrayNotEmpty(data)) return [];

  return data.map(parseSubject);
};

export default parseSubjects;



// WEBPACK FOOTER //
// ./src/services/subgroups/utils/parceSubjects.ts